module.exports = __webpack_public_path__ + "static/media/6.0bf3ffe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/6.png
// module id = 1214
// module chunks = 0